import { defineMessages } from '@/i18n'

/** The admin Change Log (audit trail) and its detail dialog. */
export const changelogMessages = defineMessages({
  en: {
    changes: { one: '{count} change', other: '{count} changes' },
    allAreas: 'All areas',
    entitySession: 'Grid cell',
    entityProject: 'Project',
    entityRtkSegment: 'RTK geometry',
    entityProjectRequest: 'Project request',
    entityBonusConfig: 'Bonus config',
    allActions: 'All actions',
    actionCreate: 'Created',
    actionUpdate: 'Updated',
    actionDelete: 'Deleted / reset',
    allUsers: 'All users',
    fromDate: 'From date',
    toDate: 'To date',
    searchPlaceholder: 'Search value / field / item…',
    colWhen: 'When',
    colWho: 'Who',
    colAction: 'Action',
    colWhat: 'What',
    colField: 'Field',
    colChange: 'Change',
    colItem: 'Item',
    details: 'Details',
    removed: 'removed {value}',
    empty: 'No changes recorded for this filter.',
    prev: '← Prev',
    next: 'Next →',
    pageOf: 'Page {page} of {pages}',
    detailTitle: 'Change detail',
    before: 'Before',
    after: 'After',
    emptyValue: '— empty —',
    extra: 'Extra',
  },
  de: {
    changes: { one: '{count} Änderung', other: '{count} Änderungen' },
    allAreas: 'Alle Bereiche',
    entitySession: 'Tabellenzelle',
    entityProject: 'Projekt',
    entityRtkSegment: 'RTK-Geometrie',
    entityProjectRequest: 'Projektanfrage',
    entityBonusConfig: 'Bonus-Konfiguration',
    allActions: 'Alle Aktionen',
    actionCreate: 'Erstellt',
    actionUpdate: 'Geändert',
    actionDelete: 'Gelöscht / zurückgesetzt',
    allUsers: 'Alle Benutzer',
    fromDate: 'Von Datum',
    toDate: 'Bis Datum',
    searchPlaceholder: 'Wert / Feld / Element suchen…',
    colWhen: 'Wann',
    colWho: 'Wer',
    colAction: 'Aktion',
    colWhat: 'Was',
    colField: 'Feld',
    colChange: 'Änderung',
    colItem: 'Element',
    details: 'Details',
    removed: 'entfernt: {value}',
    empty: 'Für diesen Filter wurden keine Änderungen erfasst.',
    prev: '← Zurück',
    next: 'Weiter →',
    pageOf: 'Seite {page} von {pages}',
    detailTitle: 'Änderungsdetails',
    before: 'Vorher',
    after: 'Nachher',
    emptyValue: '— leer —',
    extra: 'Zusatzinfo',
  },
  cnr: {
    changes: { one: '{count} izmjena', few: '{count} izmjene', other: '{count} izmjena' },
    allAreas: 'Sve oblasti',
    entitySession: 'Ćelija tabele',
    entityProject: 'Projekat',
    entityRtkSegment: 'RTK geometrija',
    entityProjectRequest: 'Zahtjev za projekat',
    entityBonusConfig: 'Konfiguracija bonusa',
    allActions: 'Sve radnje',
    actionCreate: 'Kreirano',
    actionUpdate: 'Izmijenjeno',
    actionDelete: 'Obrisano / poništeno',
    allUsers: 'Svi korisnici',
    fromDate: 'Od datuma',
    toDate: 'Do datuma',
    searchPlaceholder: 'Pretraži vrijednost / polje / stavku…',
    colWhen: 'Kada',
    colWho: 'Ko',
    colAction: 'Radnja',
    colWhat: 'Šta',
    colField: 'Polje',
    colChange: 'Izmjena',
    colItem: 'Stavka',
    details: 'Detalji',
    removed: 'uklonjeno: {value}',
    empty: 'Nema zabilježenih izmjena za ovaj filter.',
    prev: '← Prethodna',
    next: 'Sljedeća →',
    pageOf: 'Strana {page} od {pages}',
    detailTitle: 'Detalji izmjene',
    before: 'Prije',
    after: 'Poslije',
    emptyValue: '— prazno —',
    extra: 'Dodatno',
  },
  bs: {
    changes: { one: '{count} izmjena', few: '{count} izmjene', other: '{count} izmjena' },
    allAreas: 'Sva područja',
    entitySession: 'Ćelija tabele',
    entityProject: 'Projekat',
    entityRtkSegment: 'RTK geometrija',
    entityProjectRequest: 'Zahtjev za projekat',
    entityBonusConfig: 'Konfiguracija bonusa',
    allActions: 'Sve radnje',
    actionCreate: 'Kreirano',
    actionUpdate: 'Izmijenjeno',
    actionDelete: 'Izbrisano / poništeno',
    allUsers: 'Svi korisnici',
    fromDate: 'Od datuma',
    toDate: 'Do datuma',
    searchPlaceholder: 'Pretraži vrijednost / polje / stavku…',
    colWhen: 'Kada',
    colWho: 'Ko',
    colAction: 'Radnja',
    colWhat: 'Šta',
    colField: 'Polje',
    colChange: 'Izmjena',
    colItem: 'Stavka',
    details: 'Detalji',
    removed: 'uklonjeno: {value}',
    empty: 'Nema zabilježenih izmjena za ovaj filter.',
    prev: '← Prethodna',
    next: 'Sljedeća →',
    pageOf: 'Stranica {page} od {pages}',
    detailTitle: 'Detalji izmjene',
    before: 'Prije',
    after: 'Poslije',
    emptyValue: '— prazno —',
    extra: 'Dodatno',
  },
  sr: {
    changes: { one: '{count} izmena', few: '{count} izmene', other: '{count} izmena' },
    allAreas: 'Sve oblasti',
    entitySession: 'Ćelija tabele',
    entityProject: 'Projekat',
    entityRtkSegment: 'RTK geometrija',
    entityProjectRequest: 'Zahtev za projekat',
    entityBonusConfig: 'Konfiguracija bonusa',
    allActions: 'Sve radnje',
    actionCreate: 'Kreirano',
    actionUpdate: 'Izmenjeno',
    actionDelete: 'Obrisano / poništeno',
    allUsers: 'Svi korisnici',
    fromDate: 'Od datuma',
    toDate: 'Do datuma',
    searchPlaceholder: 'Pretraži vrednost / polje / stavku…',
    colWhen: 'Kada',
    colWho: 'Ko',
    colAction: 'Radnja',
    colWhat: 'Šta',
    colField: 'Polje',
    colChange: 'Izmena',
    colItem: 'Stavka',
    details: 'Detalji',
    removed: 'uklonjeno: {value}',
    empty: 'Nema zabeleženih izmena za ovaj filter.',
    prev: '← Prethodna',
    next: 'Sledeća →',
    pageOf: 'Strana {page} od {pages}',
    detailTitle: 'Detalji izmene',
    before: 'Pre',
    after: 'Posle',
    emptyValue: '— prazno —',
    extra: 'Dodatno',
  },
})
